export default {
  install: (Vue, options) => {
    const LOGOUT = "user/logout";

    Vue.prototype.$helpers = {
      login() {
        options.$router.push("/login");
      },
      logout() {
        options.$store
          .dispatch(LOGOUT)
          .then(() => options.$router.push("/"))
          .catch(err => console.log(err));
      },
      handleFeedback(e) {
        let result = false;
        switch (e) {
          case "invalidToken":
            result = true;
            options.$store
              .dispatch(LOGOUT)
              .then(() => options.$router.push("/expired"))
              .catch(err => console.log(err));
            break;
          case "NoUserAccessRight":
            result = true;
            options.$store
              .dispatch(LOGOUT)
              .then(() => options.$router.push("/denied"))
              .catch(err => console.log(err));
            break;
          case "session_expired":
            result = true;
            options.$store
              .dispatch(LOGOUT)
              .then(() => options.$router.push("/expired"))
              .catch(err => console.log(err));
            break;
          case "invalid_session":
            result = true;
            options.$store
              .dispatch(LOGOUT)
              .then(() => options.$router.push("/expired"))
              .catch(err => console.log(err));
            break;
          case "permission_denied":
            result = false;
            if (options.$store.getters.account[0].account_type == 2) {
              options.$store
              .dispatch(LOGOUT)
              .then(() => options.$router.push("/denied"))
              .catch(err => console.log(err));

              result = true;
            }
            break;
        }

        return result;
      },
      fontClassName(item, isLink) {
        isLink = isLink || false;
        if (parseFloat(item) < 0)
          return 'text-danger';
        else if (parseFloat(item) == 0)
          return '';
        else {
          if (isLink == true)
            return 'text-info';
          else
            return '';
        }
      },
      alert(title, message, variant) {
        return options.$swal(title, message, variant);
      },
      showDialog(title, message, variant) {
        options.$swal(title, message, variant);
      },
      showToast(title, message, variant) {
        options.$swal(title, message, variant);
      },
      showMatchInfo(title, message, variant) {
        return options.$swal(title, message, variant);
      },
      rowClass: function(item) {
        if (!item) return
        if (item.status.toUpperCase() === 'BLOCK' || item.status.toUpperCase() === 'SUSPEND') return 'bg-yellow'
        if (item.status.toUpperCase() === 'CLOSE')  return 'bg-blue'
        if (item.status.toUpperCase() === 'FREEZE')  return 'bg-red'
      },
      rowClassBit: function(item) {
        if (item == null) return
        if (item == false) return 'bg-yellow'
      },
      rowClassBitPromo: function(status) {
        if (status == null) return
        if (status == false) return 'bg-yellow'
      },
      rowClassTicket: function(item) {
        if (!item) return
        // if (item.deposit_method.toUpperCase() === 'ONLINE')  return 'bg-blue'
        if (item.target_bank_id.toUpperCase() != 'GATEWAY')  return 'bg-blue'
      },
      isNumeric(str) {
        return /^\d+$/.test(str);
      }
    };
  }
};
